import { render } from "./HotkeyItemModal.vue?vue&type=template&id=34f1b15f&scoped=true"
import script from "./HotkeyItemModal.vue?vue&type=script&lang=js"
export * from "./HotkeyItemModal.vue?vue&type=script&lang=js"

import "./HotkeyItemModal.vue?vue&type=style&index=0&id=34f1b15f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34f1b15f"]])

export default __exports__